import axios from "axios";
import cookie from "vue-cookie";
import config from "./config";

export const MEMBER_REQUIRED_EVENT = "member-access-required";

const AUTH_PATHS = [
  "/user/login", "/user/loginByEmailAndPwd", "/user/loginByOpenId",
  "/user/iphoneLogin", "/user/iphoneLoginOrRegister",
  "/user/userRegisterEmailNoCode", "/user/user_register_telephone",
  "/user/user_register_email", "/user/verifySmsCode",
  "/user/verifySmsCodeUpdatePwd", "/user/verifyPhoneCodeUndel",
  "/user/send_verifyCode", "/user/send_email_code", "/user/forgetPassword",
  "/user/updateEmailPwd", "/user/check_phone_is_flag",
  "/user/check_email_is_flag", "/user/ajaxLogout",
  "/wechat/get_wechat_login_url",
];

const APP_BOOTSTRAP_PATHS = [
  "/user/getUserInfo",
  "/user/getOldUserInfo",
  "/user/getMyTeam",
  "/user/getMyJoinedTeam",
  "/companyUser/queryPageByCompanyCode",
  "/user/queryPlatformByHost",
  "/resource/queryRes",
  "/resource/queryUserRoleResource",
  "/fileTask/userIdToTaskClassificationNum",
];

let membershipRequest = null;
let dialogRequested = false;

const normalizePath = (path = "") => {
  try {
    return new URL(path, window.location.origin).pathname;
  } catch (e) {
    return String(path).split("?")[0];
  }
};

const getCurrentUserId = () => {
  const keys = ["userInfo", "myUser"];
  for (let index = 0; index < keys.length; index += 1) {
    try {
      const user = JSON.parse(localStorage.getItem(keys[index]) || "{}");
      if (user.id) return String(user.id);
    } catch (e) {
      // Ignore invalid historical local storage values.
    }
  }
  return "";
};

export const isMemberCheckExcluded = (path, serverType) => {
  const normalizedPath = normalizePath(path);
  if (serverType === "PaymentAPI" || normalizedPath.indexOf("/payment/") === 0) {
    return true;
  }
  return [...AUTH_PATHS, ...APP_BOOTSTRAP_PATHS].some(
    (authPath) => normalizedPath === authPath || normalizedPath.endsWith(authPath)
  );
};

const requestMembership = (userId) => {
  if (!membershipRequest) {
    const token = cookie.get("token") || {};
    const headers = {
      "Content-Type": "application/json;charset=UTF-8",
      "is-ajax-request": "true",
      "client-name": CAS_CLIENT_NAME,
    };
    if (token.Authorization) headers.Authorization = token.Authorization;

    // Standalone request: the membership check cannot intercept itself.
    membershipRequest = axios({
      method: "GET",
      headers,
      url: `${config.PaymentAPI}/api/member/users/${userId}/membership`,
    })
      .then((response) => response.data || {})
      .finally(() => {
        membershipRequest = null;
      });
  }
  return membershipRequest;
};

export const ensureMemberAccess = async (path, serverType) => {
  if (isMemberCheckExcluded(path, serverType)) return true;
  const userId = getCurrentUserId();
  if (!userId) return true;

  const memberInfo = await requestMembership(userId);
  if (memberInfo.active === true) {
    dialogRequested = false;
    return true;
  }
  if (!dialogRequested) {
    dialogRequested = true;
    window.dispatchEvent(
      new CustomEvent(MEMBER_REQUIRED_EVENT, { detail: memberInfo })
    );
  }
  return false;
};

export const resetMemberAccessDialog = () => {
  dialogRequested = false;
};
